// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Dexasign SDK Styles
 */

/* Verify Modal Content */
.auth-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.auth-prompt {
    text-align: center;
}

.auth-prompt h1 {
    font-size: 28px;
    font-weight: 700;
    color: #0A2540;
    margin: 0 0 16px 0;
}

.auth-controls {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-top: 20px;
}

.btn-primary {
    padding: 12px 32px;
    background: #0A2540;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}

.btn-primary:hover {
    background: #1a3a5f;
}

.btn-secondary {
    padding: 12px 32px;
    background: white;
    color: #0A2540;
    border: 2px solid #0A2540;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-secondary:hover {
    background: #F9FAFB;
}

.auth-footer {
    text-align: center;
    padding: 16px 0;
    color: #6B7280;
    font-size: 13px;
}

.video-wrapper {
    position: relative;
    width: 100%;
    max-width: 640px;
    margin: 0 auto;
    background: #F9FAFB;
    border-radius: 12px;
    overflow: hidden;
    /* Subtle animated cloud shadow */
    box-shadow: 
        0 4px 12px rgba(0, 0, 0, 0.15),
        0 0 20px rgba(0, 200, 83, 0.15),
        8px 0 25px rgba(105, 240, 174, 0.1),
        -8px 0 25px rgba(0, 230, 118, 0.1);
    animation: shadow-drift 4s ease-in-out infinite;
}

/* Subtle drifting shadow animation */
@keyframes shadow-drift {
    0%, 100% {
        box-shadow: 
            0 4px 12px rgba(0, 0, 0, 0.15),
            0 0 20px rgba(0, 200, 83, 0.12),
            10px 5px 25px rgba(105, 240, 174, 0.08),
            -8px -3px 25px rgba(0, 230, 118, 0.08);
    }
    33% {
        box-shadow: 
            0 4px 12px rgba(0, 0, 0, 0.15),
            0 0 22px rgba(0, 200, 83, 0.15),
            -5px 8px 28px rgba(105, 240, 174, 0.1),
            12px -5px 22px rgba(0, 230, 118, 0.06);
    }
    66% {
        box-shadow: 
            0 4px 12px rgba(0, 0, 0, 0.15),
            0 0 18px rgba(0, 200, 83, 0.1),
            6px -6px 24px rgba(105, 240, 174, 0.07),
            -10px 6px 26px rgba(0, 230, 118, 0.12);
    }
}

/* Flash effect when gesture captured */
.video-wrapper.gesture-flash {
    animation: shadow-flash 0.75s ease-out;
}

@keyframes shadow-flash {
    0% {
        box-shadow: 
            0 4px 12px rgba(0, 0, 0, 0.15),
            0 0 40px rgba(0, 200, 83, 0.6),
            0 0 60px rgba(105, 240, 174, 0.4),
            0 0 80px rgba(0, 230, 118, 0.3);
    }
    100% {
        box-shadow: 
            0 4px 12px rgba(0, 0, 0, 0.15),
            0 0 20px rgba(0, 200, 83, 0.12),
            10px 5px 25px rgba(105, 240, 174, 0.08),
            -8px -3px 25px rgba(0, 230, 118, 0.08);
    }
}

/* No animation mode - static shadow only */
.video-wrapper.no-animation {
    animation: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.video-wrapper.no-animation.gesture-flash {
    animation: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Space Mission mode — black background, no glow animation */
.video-wrapper.space-mission {
    background: #000;
    animation: none;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7), 0 0 30px rgba(80, 80, 200, 0.12);
}
.video-wrapper.space-mission video {
    opacity: 0;
}
.video-wrapper.space-mission.gesture-flash {
    animation: none;
}

.video-wrapper video {
    width: 100%;
    height: auto;
    display: block;
    transform: scaleX(-1);
}

.video-wrapper canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    z-index: 100;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.status-message {
    text-align: center;
    min-height: 24px;
}

.status-message #authStatus {
    font-size: 16px;
    font-weight: 600;
    color: #0A2540;
}

/* Container */
.dexasign-auth-screen,
.dexasign-onboarding-screen {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    box-sizing: border-box;
}

/* Header */
.dexasign-header {
    text-align: center;
    margin-bottom: 30px;
}

.dexasign-header h1 {
    color: #0A2540;
    font-size: 28px;
    margin: 0 0 10px 0;
}

.dexasign-email {
    color: #425466;
    font-size: 16px;
    margin: 0;
}

/* Video Container */
.dexasign-video-container {
    position: relative;
    width: 100%;
    max-width: 640px;
    margin: 0 auto 20px;
    background: #000;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

#dexasign-webcam {
    width: 100%;
    height: auto;
    display: block;
    transform: scaleX(-1);
}

#dexasign-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

/* Status */
.dexasign-status {
    text-align: center;
    margin: 20px 0;
}

.dexasign-status p {
    font-size: 18px;
    color: #0A2540;
    margin: 10px 0;
}

#dexasign-auth-status,
#dexasign-onboarding-status {
    font-weight: 600;
    font-size: 20px;
}

.dexasign-status-success {
    color: #00C853 !important;
}

.dexasign-status-error {
    color: #D50000 !important;
}

.dexasign-gesture-count {
    font-size: 16px;
    color: #425466;
}

#dexasign-gesture-count {
    font-weight: 700;
    color: #0A2540;
}

/* Gesture Details */
.dexasign-gesture-details {
    background: #F7FAFC;
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    padding: 20px;
    margin: 20px 0;
}

.gesture-sequence-title {
    font-weight: 700;
    font-size: 18px;
    color: #0A2540;
    margin-bottom: 15px;
}

.gesture-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background: white;
    border-radius: 6px;
    margin-bottom: 8px;
}

.gesture-number {
    font-weight: 700;
    color: #0A2540;
    min-width: 25px;
}

.gesture-hand {
    font-weight: 600;
    color: #0A2540;
    min-width: 80px;
}

.gesture-count {
    color: #425466;
}

.gesture-fingers {
    color: #64748B;
    font-size: 14px;
}

/* Verification Progress */
.dexasign-verification-progress {
    text-align: center;
    margin: 20px 0;
}

.dexasign-verification-progress p {
    font-weight: 600;
    color: #0A2540;
    margin-bottom: 10px;
}

.dexasign-progress-dots {
    display: flex;
    justify-content: center;
    gap: 15px;
}

.dexasign-progress-dot {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #E2E8F0;
    color: #64748B;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 16px;
    transition: all 0.3s ease;
}

.dexasign-progress-dot.completed {
    background: #00C853;
    color: white;
}

/* Actions */
.dexasign-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin: 30px 0;
}

.dexasign-btn {
    padding: 14px 32px;
    font-size: 16px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: inherit;
}

.dexasign-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dexasign-btn:active {
    transform: translateY(0);
}

.dexasign-btn-primary {
    background: #0A2540;
    color: white;
}

.dexasign-btn-primary:hover {
    background: #1a3a5f;
}

.dexasign-btn-secondary {
    background: #E2E8F0;
    color: #0A2540;
}

.dexasign-btn-secondary:hover {
    background: #CBD5E0;
}

/* Loading Overlay */
.dexasign-loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.dexasign-loading p {
    color: white;
    font-size: 18px;
    margin-top: 20px;
}

/* Spinner */
.dexasign-spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: dexasign-spin 1s linear infinite;
}

@keyframes dexasign-spin {
    to {
        transform: rotate(360deg);
    }
}

/* Responsive */
@media (max-width: 768px) {
    .dexasign-auth-screen,
    .dexasign-onboarding-screen {
        padding: 15px;
    }

    .dexasign-header h1 {
        font-size: 24px;
    }

    .dexasign-email {
        font-size: 14px;
    }

    #dexasign-auth-status,
    #dexasign-onboarding-status {
        font-size: 18px;
    }

    .dexasign-btn {
        padding: 12px 24px;
        font-size: 14px;
    }

    .dexasign-actions {
        flex-direction: column;
        gap: 10px;
    }

    .gesture-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
}

@media (max-width: 480px) {
    .dexasign-header h1 {
        font-size: 20px;
    }

    .dexasign-progress-dots {
        gap: 10px;
    }

    .dexasign-progress-dot {
        width: 35px;
        height: 35px;
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;IACjC;;;;0CAIsC;IACtC,+CAA+C;AACnD;;AAEA,qCAAqC;AACrC;IACI;QACI;;;;kDAI0C;IAC9C;IACA;QACI;;;;kDAI0C;IAC9C;IACA;QACI;;;;kDAI0C;IAC9C;AACJ;;AAEA,uCAAuC;AACvC;IACI,sCAAsC;AAC1C;;AAEA;IACI;QACI;;;;2CAImC;IACvC;IACA;QACI;;;;kDAI0C;IAC9C;AACJ;;AAEA,2CAA2C;AAC3C;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA,6DAA6D;AAC7D;IACI,gBAAgB;IAChB,eAAe;IACf,2EAA2E;AAC/E;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,cAAc;AACd;;IAEI,yGAAyG;IACzG,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,eAAe;AACf;IACI;;QAEI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":["/**\r\n * Dexasign SDK Styles\r\n */\r\n\r\n/* Verify Modal Content */\r\n.auth-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 20px;\r\n}\r\n\r\n.auth-prompt {\r\n    text-align: center;\r\n}\r\n\r\n.auth-prompt h1 {\r\n    font-size: 28px;\r\n    font-weight: 700;\r\n    color: #0A2540;\r\n    margin: 0 0 16px 0;\r\n}\r\n\r\n.auth-controls {\r\n    display: flex;\r\n    gap: 12px;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n.btn-primary {\r\n    padding: 12px 32px;\r\n    background: #0A2540;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.btn-primary:hover {\r\n    background: #1a3a5f;\r\n}\r\n\r\n.btn-secondary {\r\n    padding: 12px 32px;\r\n    background: white;\r\n    color: #0A2540;\r\n    border: 2px solid #0A2540;\r\n    border-radius: 8px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.btn-secondary:hover {\r\n    background: #F9FAFB;\r\n}\r\n\r\n.auth-footer {\r\n    text-align: center;\r\n    padding: 16px 0;\r\n    color: #6B7280;\r\n    font-size: 13px;\r\n}\r\n\r\n.video-wrapper {\r\n    position: relative;\r\n    width: 100%;\r\n    max-width: 640px;\r\n    margin: 0 auto;\r\n    background: #F9FAFB;\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n    /* Subtle animated cloud shadow */\r\n    box-shadow: \r\n        0 4px 12px rgba(0, 0, 0, 0.15),\r\n        0 0 20px rgba(0, 200, 83, 0.15),\r\n        8px 0 25px rgba(105, 240, 174, 0.1),\r\n        -8px 0 25px rgba(0, 230, 118, 0.1);\r\n    animation: shadow-drift 4s ease-in-out infinite;\r\n}\r\n\r\n/* Subtle drifting shadow animation */\r\n@keyframes shadow-drift {\r\n    0%, 100% {\r\n        box-shadow: \r\n            0 4px 12px rgba(0, 0, 0, 0.15),\r\n            0 0 20px rgba(0, 200, 83, 0.12),\r\n            10px 5px 25px rgba(105, 240, 174, 0.08),\r\n            -8px -3px 25px rgba(0, 230, 118, 0.08);\r\n    }\r\n    33% {\r\n        box-shadow: \r\n            0 4px 12px rgba(0, 0, 0, 0.15),\r\n            0 0 22px rgba(0, 200, 83, 0.15),\r\n            -5px 8px 28px rgba(105, 240, 174, 0.1),\r\n            12px -5px 22px rgba(0, 230, 118, 0.06);\r\n    }\r\n    66% {\r\n        box-shadow: \r\n            0 4px 12px rgba(0, 0, 0, 0.15),\r\n            0 0 18px rgba(0, 200, 83, 0.1),\r\n            6px -6px 24px rgba(105, 240, 174, 0.07),\r\n            -10px 6px 26px rgba(0, 230, 118, 0.12);\r\n    }\r\n}\r\n\r\n/* Flash effect when gesture captured */\r\n.video-wrapper.gesture-flash {\r\n    animation: shadow-flash 0.75s ease-out;\r\n}\r\n\r\n@keyframes shadow-flash {\r\n    0% {\r\n        box-shadow: \r\n            0 4px 12px rgba(0, 0, 0, 0.15),\r\n            0 0 40px rgba(0, 200, 83, 0.6),\r\n            0 0 60px rgba(105, 240, 174, 0.4),\r\n            0 0 80px rgba(0, 230, 118, 0.3);\r\n    }\r\n    100% {\r\n        box-shadow: \r\n            0 4px 12px rgba(0, 0, 0, 0.15),\r\n            0 0 20px rgba(0, 200, 83, 0.12),\r\n            10px 5px 25px rgba(105, 240, 174, 0.08),\r\n            -8px -3px 25px rgba(0, 230, 118, 0.08);\r\n    }\r\n}\r\n\r\n/* No animation mode - static shadow only */\r\n.video-wrapper.no-animation {\r\n    animation: none;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.video-wrapper.no-animation.gesture-flash {\r\n    animation: none;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* Space Mission mode — black background, no glow animation */\r\n.video-wrapper.space-mission {\r\n    background: #000;\r\n    animation: none;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7), 0 0 30px rgba(80, 80, 200, 0.12);\r\n}\r\n.video-wrapper.space-mission video {\r\n    opacity: 0;\r\n}\r\n.video-wrapper.space-mission.gesture-flash {\r\n    animation: none;\r\n}\r\n\r\n.video-wrapper video {\r\n    width: 100%;\r\n    height: auto;\r\n    display: block;\r\n    transform: scaleX(-1);\r\n}\r\n\r\n.video-wrapper canvas {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    pointer-events: none;\r\n}\r\n\r\n.loading-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.8);\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: white;\r\n    z-index: 100;\r\n}\r\n\r\n.loading-spinner {\r\n    width: 40px;\r\n    height: 40px;\r\n    border: 4px solid rgba(255, 255, 255, 0.3);\r\n    border-top-color: white;\r\n    border-radius: 50%;\r\n    animation: spin 0.8s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n    to { transform: rotate(360deg); }\r\n}\r\n\r\n.status-message {\r\n    text-align: center;\r\n    min-height: 24px;\r\n}\r\n\r\n.status-message #authStatus {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #0A2540;\r\n}\r\n\r\n/* Container */\r\n.dexasign-auth-screen,\r\n.dexasign-onboarding-screen {\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n/* Header */\r\n.dexasign-header {\r\n    text-align: center;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.dexasign-header h1 {\r\n    color: #0A2540;\r\n    font-size: 28px;\r\n    margin: 0 0 10px 0;\r\n}\r\n\r\n.dexasign-email {\r\n    color: #425466;\r\n    font-size: 16px;\r\n    margin: 0;\r\n}\r\n\r\n/* Video Container */\r\n.dexasign-video-container {\r\n    position: relative;\r\n    width: 100%;\r\n    max-width: 640px;\r\n    margin: 0 auto 20px;\r\n    background: #000;\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n#dexasign-webcam {\r\n    width: 100%;\r\n    height: auto;\r\n    display: block;\r\n    transform: scaleX(-1);\r\n}\r\n\r\n#dexasign-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    pointer-events: none;\r\n}\r\n\r\n/* Status */\r\n.dexasign-status {\r\n    text-align: center;\r\n    margin: 20px 0;\r\n}\r\n\r\n.dexasign-status p {\r\n    font-size: 18px;\r\n    color: #0A2540;\r\n    margin: 10px 0;\r\n}\r\n\r\n#dexasign-auth-status,\r\n#dexasign-onboarding-status {\r\n    font-weight: 600;\r\n    font-size: 20px;\r\n}\r\n\r\n.dexasign-status-success {\r\n    color: #00C853 !important;\r\n}\r\n\r\n.dexasign-status-error {\r\n    color: #D50000 !important;\r\n}\r\n\r\n.dexasign-gesture-count {\r\n    font-size: 16px;\r\n    color: #425466;\r\n}\r\n\r\n#dexasign-gesture-count {\r\n    font-weight: 700;\r\n    color: #0A2540;\r\n}\r\n\r\n/* Gesture Details */\r\n.dexasign-gesture-details {\r\n    background: #F7FAFC;\r\n    border: 1px solid #E2E8F0;\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    margin: 20px 0;\r\n}\r\n\r\n.gesture-sequence-title {\r\n    font-weight: 700;\r\n    font-size: 18px;\r\n    color: #0A2540;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.gesture-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 10px;\r\n    background: white;\r\n    border-radius: 6px;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.gesture-number {\r\n    font-weight: 700;\r\n    color: #0A2540;\r\n    min-width: 25px;\r\n}\r\n\r\n.gesture-hand {\r\n    font-weight: 600;\r\n    color: #0A2540;\r\n    min-width: 80px;\r\n}\r\n\r\n.gesture-count {\r\n    color: #425466;\r\n}\r\n\r\n.gesture-fingers {\r\n    color: #64748B;\r\n    font-size: 14px;\r\n}\r\n\r\n/* Verification Progress */\r\n.dexasign-verification-progress {\r\n    text-align: center;\r\n    margin: 20px 0;\r\n}\r\n\r\n.dexasign-verification-progress p {\r\n    font-weight: 600;\r\n    color: #0A2540;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.dexasign-progress-dots {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 15px;\r\n}\r\n\r\n.dexasign-progress-dot {\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    background: #E2E8F0;\r\n    color: #64748B;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.dexasign-progress-dot.completed {\r\n    background: #00C853;\r\n    color: white;\r\n}\r\n\r\n/* Actions */\r\n.dexasign-actions {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 15px;\r\n    margin: 30px 0;\r\n}\r\n\r\n.dexasign-btn {\r\n    padding: 14px 32px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    font-family: inherit;\r\n}\r\n\r\n.dexasign-btn:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.dexasign-btn:active {\r\n    transform: translateY(0);\r\n}\r\n\r\n.dexasign-btn-primary {\r\n    background: #0A2540;\r\n    color: white;\r\n}\r\n\r\n.dexasign-btn-primary:hover {\r\n    background: #1a3a5f;\r\n}\r\n\r\n.dexasign-btn-secondary {\r\n    background: #E2E8F0;\r\n    color: #0A2540;\r\n}\r\n\r\n.dexasign-btn-secondary:hover {\r\n    background: #CBD5E0;\r\n}\r\n\r\n/* Loading Overlay */\r\n.dexasign-loading {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.7);\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 9999;\r\n}\r\n\r\n.dexasign-loading p {\r\n    color: white;\r\n    font-size: 18px;\r\n    margin-top: 20px;\r\n}\r\n\r\n/* Spinner */\r\n.dexasign-spinner {\r\n    width: 50px;\r\n    height: 50px;\r\n    border: 4px solid rgba(255, 255, 255, 0.3);\r\n    border-top-color: white;\r\n    border-radius: 50%;\r\n    animation: dexasign-spin 1s linear infinite;\r\n}\r\n\r\n@keyframes dexasign-spin {\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n    .dexasign-auth-screen,\r\n    .dexasign-onboarding-screen {\r\n        padding: 15px;\r\n    }\r\n\r\n    .dexasign-header h1 {\r\n        font-size: 24px;\r\n    }\r\n\r\n    .dexasign-email {\r\n        font-size: 14px;\r\n    }\r\n\r\n    #dexasign-auth-status,\r\n    #dexasign-onboarding-status {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .dexasign-btn {\r\n        padding: 12px 24px;\r\n        font-size: 14px;\r\n    }\r\n\r\n    .dexasign-actions {\r\n        flex-direction: column;\r\n        gap: 10px;\r\n    }\r\n\r\n    .gesture-item {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 5px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .dexasign-header h1 {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .dexasign-progress-dots {\r\n        gap: 10px;\r\n    }\r\n\r\n    .dexasign-progress-dot {\r\n        width: 35px;\r\n        height: 35px;\r\n        font-size: 14px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
